import { _http } from "../_http";
import fileDownload from "js-file-download";
import { BASE_URL } from "../../CONSTANTS";

export type File = {
  _id: string;
  path: string;
  name: string;
  fieldname?: string;
  encoding?: string;
  mimetype?: string;
  size?: string;
  __v?: number;
};

export type FileSOfFolder = {
  status: string;
  data: {
    files: File[];
    folders: string[];
  };
};

export type FolderWithId = {
  name: string;
  _id: string;
};

export async function getFilesFolders(filePath: string) {
  // console.log("from get files and folders");
  const data = await _http.post<FileSOfFolder>("ticket-files/getFolderFiles", {
    path: filePath,
  });
  if (data.status === 201) return data;
}

export async function createFolder(path: string, name: string) {
  return await _http.post(`ticket-files/createFolder`, { path, name });
}

export async function addFile(body) {
  return await _http.post(`ticket-files/upload`, body);
  // if (data?.data?.status === "failed") {
  //     throw Error(data.data);
  // }
}

export async function deleteFile(id: string) {
  const res = await _http.delete(`ticket-files/${id}`);
}

export async function deleteFolder(data: { path: string }) {
  await _http.delete(`ticket-files/deleteFolder`, { data });
}

export type RenameFolder = { path: string; name: string };
export async function reNameFolder(body: RenameFolder) {
  return _http.post(`ticket-files/renameFolder`, body);
}

export const downloadFile = (filePath: string, fileName = "download") => {
  _http.get(`${BASE_URL}${filePath}`, { responseType: "blob" }).then((res) => {
    fileDownload(res.data, fileName);
  });
};
